import React, { useState } from 'react';
import Nav from './Nav';

export default function SideBar({ fullMenu, subsInView }) {
	
	const [headerOpen, toggleHeader] = useState(false);
	
  return (
    <header id="header" className={`${fullMenu ? '' : 'alt'} ${subsInView ? 'subs-in-view' : ''}`}>      
      <div className={`${headerOpen ? 'is-menu-visible' : ' '}`}>
        <Nav onMenuToggle={() => toggleHeader(!headerOpen)} />
      </div>
    </header>
  );
}
